import React from 'react';

type MarkdownLinkProps = React.AnchorHTMLAttributes<HTMLAnchorElement> & {
  node?: unknown;
};

const ExternalMarkdownLink: React.FC<MarkdownLinkProps> = ({ node: _node, ...props }) => (
  <a {...props} target="_blank" rel="noopener noreferrer" />
);

export default ExternalMarkdownLink;
